<template>
  <div>
    <validation-observer ref="formTomadorSegurados" v-slot="{ invalid }">
      <!-- CPF Tomador -->
      <b-row>
        <b-col md="4">
          <b-form-group label="CPF" label-for="cpf">
            <validation-provider #default="{ errors }" name="CPF" rules="required|cpf">
              <cleave
                id="cpf"
                type="text"
                placeholder="CPF"
                v-model="dados.cpf"
                :raw="false"
                :options="options.cleaveCPF"
                class="form-control"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col :md="4">
          <b-form-group label="Data Nascimento" label-for="dataNascimento">
            <validation-provider #default="{ errors }" name="Data Nascimento" rules="required|date">
              <cleave
                id="dataNascimento"
                class="form-control"
                type="text"
                placeholder="DD/MM/AAAA"
                v-model="dados.dataNascimento"
                :options="options.cleaveDate"
                :raw="false"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col :md="4">
          <b-form-group label="Unidade Gestora" label-for="unidadeGestora">
            <validation-provider #default="{ errors }" name="Unidade Gestora" rules="required">
              <v-select-pt
                id="selectUnidadeGestora"
                name="selectUnidadeGestora"
                v-model="dados.unidadeGestoraId"
                v-bloqueioCaractereMask="{ tamanho: 50, regex: /[^a-zA-Z]/g }"
                :options="unidadeGestoras"
                :reduce="(option) => option.id"
                label="nome"
                placeholder="Selecione:"
                :clearable="false"
                @input="carregarOrgaos"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>

      <b-col md="12" class="mt-2">
        <div class="d-flex justify-content-between align-items-center">
          <h4>Segurado(s)</h4>
          <b-button variant="primary" @click="adicionarSegurado" class="btn-sm h1"> + </b-button>
        </div>
        <div v-for="(segurado, index) in dados.segurados" :key="index" class="">
          <b-row>
            <b-col :md="dados.segurados.length > 1 ? 3 : 4">
              <b-form-group label="Matrícula" :label-for="`matricula-${index}`">
                <validation-provider #default="{ errors }" rules="required" :name="`Matrícula ${index + 1}`">
                  <b-form-input :id="`matricula-${index}`" type="text" placeholder="Matrícula" v-model="segurado.matricula" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col :md="dados.segurados.length > 1 ? 3 : 4">
              <b-form-group label="Categoria" label-for="categoria">
                <validation-provider #default="{ errors }" name="Categoria" rules="required">
                  <b-form-select name="categoria" v-model="segurado.categoria" :options="categoriaOpcoes"></b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Órgão -->
            <b-col :md="dados.segurados.length > 1 ? 4 : 4">
              <b-form-group label="Órgão" :label-for="`orgao-${index}`">
                <validation-provider #default="{ errors }" rules="required" :name="`Órgão ${index + 1}`">
                  <v-select-pt
                    :name="`orgao-${index}`"
                    v-model="segurado.orgaoId"
                    :options="orgaos"
                    :reduce="(option) => option.id"
                    label="nome"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Botão Remover -->
            <b-col md="1" class="d-flex align-items-center">
              <b-button
                variant="danger"
                @click="removerSegurado(index)"
                class="btn-sm tw-mb-1 d-flexjustify-content-center align-items-center"
                v-if="dados.segurados.length > 1 && !dados.segurados[index].id"
              >
                Remover
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col md="12">
        <b-button name="btnCreateEditSegurado" variant="primary" @click="createEditSegurado()" class="w-100 mt-4">
          Salvar
        </b-button>
      </b-col>
    </validation-observer>
  </div>
</template>

<script>
  import Cleave from 'vue-cleave-component'
  import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
  import useJwt from '@/auth/jwt/useJwt'
  import { formatarData, formatarDataGlobal, isCPFValid } from '@/libs/utils'

  extend('cpf', {
    validate: (value) => isCPFValid(value),
    message: 'CPF inválido',
  })

  export default {
    components: {
      Cleave,
      ValidationObserver,
      ValidationProvider,
    },
    props: {
      editTomadorFastRegister: {
        type: Number,
      },
    },

    data() {
      return {
        dados: {
          id: null, // novo campo
          cpf: '',
          dataNascimento: '',
          unidadeGestoraId: null,
          segurados: [{ id: null, matricula: '', orgaoId: null, categoria: '' }],
        },
        options: {
          cleaveCPF: {
            delimiters: ['.', '.', '-'],
            blocks: [3, 3, 3, 2],
            numericOnly: true,
          },
          cleaveDate: {
            date: true,
            delimiter: '/',
            datePattern: ['d', 'm', 'Y'],
          },
        },
        categoriaOpcoes: [
          { value: '', text: 'Selecione' },
          { value: 'Efetivo', text: 'Efetivo' },
          { value: 'Estavel', text: 'Estável' },
          { value: 'Pensionista', text: 'Pensionista' },
          { value: 'Aposentado', text: 'Aposentado' },
        ],
        orgaos: [],
        unidadeGestoras: [],
      }
    },
    mounted() {
      this.carregarUnidadeGestora()
      if (this.editTomadorFastRegister) {
        this.carregarDadosTomador(this.editTomadorFastRegister)
      }
    },
    methods: {
      adicionarSegurado() {
        this.dados.segurados.push({ id: null, matricula: '', orgaoId: null, categoria: '' })
      },
      removerSegurado(index) {
        this.dados.segurados.splice(index, 1)
      },

      carregarOrgaos() {
        useJwt
          .get(`cadastro/orgao`)
          .then((response) => {
            this.orgaos = response.data.filter((agencyId) => agencyId.institutoId == this.dados.unidadeGestoraId)
          })
          .catch((error) => {
            console.error(error)
          })
      },

      async carregarDadosTomador(id) {
        try {
          const response = await useJwt.get(`cadastro/tomador/${id}`)
          this.dados.unidadeGestoraId = response.data.institutoId || null
          this.carregarOrgaos()
          this.dados = {
            id: response.data.id,
            cpf: response.data.cpf || '',
            dataNascimento: formatarData(response.data.dataNascimento),
            unidadeGestoraId: response.data.institutoId || null,
            segurados: (response.data.segurado || []).map((s) => ({
              id: s.id,
              matricula: s.matricula || '',
              orgaoId: s.orgao?.id || null,
              categoria: s.situacaoPrevidenciaria || null,
            })),
          }
        } catch (error) {
          console.error('Erro ao carregar tomador:', error)
        }
      },

      async createEditSegurado() {
        try {
          await this.$refs.formTomadorSegurados.validate().then(async (valid) => {
            if (valid) {
              const payload = {
                id: this.dados.id,
                cpf: this.dados.cpf,
                dataNascimento: formatarDataGlobal(this.dados.dataNascimento),
                unidadeGestoraId: this.dados.unidadeGestoraId,
                segurados: this.dados.segurados.map((s) => ({
                  id: s.id,
                  matricula: s.matricula,
                  categoria: s.categoria,
                  orgaoId: s.orgaoId,
                })),
              }

              await useJwt.post('/cadastro/tomador/fastRegister', payload)

              if (this.dados.id) this.$message.success('Editado com sucesso.')
              else this.$message.success('Cadastro atualizado com sucesso.')

              this.limparFormulario()
              this.$emit('atualizaGrid')
              this.$emit('closeFastRegister')
            }
          })
        } catch (error) {
          if (error.response && error.response.status === 409) {
            this.$message.error('Tomador já cadastrado no sistema')
          } else {
            this.$message.error('Erro ao cadastrar tomador')
          }
        }
      },
      limparFormulario() {
        this.dados = {
          id: null,
          cpf: '',
          segurados: [{ id: null, matricula: '', orgaoId: null, categoria: '' }],
        }

        this.$refs.formTomadorSegurados.reset()

        this.$nextTick(() => {
          this.dados.segurados = [{ id: null, matricula: '', orgaoId: null, categoria: '' }]
        })
      },

      carregarUnidadeGestora() {
        useJwt
          .get('cadastro/instituto')
          .then((response) => {
            this.unidadeGestoras = response.data
          })
          .catch((error) => {
            console.error(error)
          })
      },
    },
  }
</script>
